module.exports = __webpack_public_path__ + "img/cover_en.91f9f45a.jpg";